import { render, staticRenderFns } from "./PropostaEncaminhada.vue?vue&type=template&id=93a992bc&scoped=true&"
import script from "./PropostaEncaminhada.vue?vue&type=script&lang=js&"
export * from "./PropostaEncaminhada.vue?vue&type=script&lang=js&"
import style0 from "./PropostaEncaminhada.vue?vue&type=style&index=0&id=93a992bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a992bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
